import SearchForm from "../Components/SearchForm";
import React, { useState, useEffect } from "react";
import useToken from "../Components/useToken";
import { Offcanvas } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";

const REGIONI_ITALIANE = [
  "Abruzzo",
  "Basilicata",
  "Calabria",
  "Campania",
  "Emilia-Romagna",
  "Friuli-Venezia Giulia",
  "Lazio",
  "Liguria",
  "Lombardia",
  "Marche",
  "Molise",
  "Piemonte",
  "Puglia",
  "Sardegna",
  "Sicilia",
  "Toscana",
  "Trentino-Alto Adige",
  "Umbria",
  "Valle d'Aosta",
  "Veneto",
];

async function getNazioni(token) {
  let result = await fetch(`${process.env.REACT_APP_API_KEY}/admin/nazione`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((data) => data.json());
  return result;
}

async function getSingleTag(token, id) {
  let result = await fetch(`${process.env.REACT_APP_API_KEY}/admin/tag/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((data) => data.json());
  return result;
}

async function checkCampiTag(nome, luogo, file, upload_preview) {
  if (
    file &&
    file.type != "image/png" &&
    file &&
    file.type != "image/jpeg" &&
    file &&
    file.type != "image/webp" &&
    file &&
    file.type != "image/jpg"
  ) {
    return "Formato Immagine non supportato.";
  }
  if (file && file.size > 10000000) {
    return "Immagine troppo pesante. Inserire immagine più leggera.";
  }

  if (upload_preview == "/immagine_profilo_default.svg") {
    return "Errore. Inserire Immagine";
  }

  if (!nome || nome == "") {
    return "Errore. Inserire nome";
  }
  if (!luogo || luogo == "") {
    return "Errore. Inserire una nazione o un luogo.";
  } else return true;
}

async function getNazione(token, id) {
  let result = await fetch(
    `${process.env.REACT_APP_API_KEY}/admin/nazione/${id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  ).then((data) => data.json());
  return result;
}

async function insertNazione(token, title) {
  let result = await axios.post(
    `${process.env.REACT_APP_API_KEY}/admin/nazione`,
    {
      title: title,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true",
      },
    }
  );
  return result.data;
}

async function updatetag(camminoUpdate, token) {
  console.log(camminoUpdate);

  const formData = new FormData();

  if (camminoUpdate.img && camminoUpdate.img != undefined) {
    formData.append("profileImg", camminoUpdate.img);
    formData.append(
      "body",
      JSON.stringify({
        nome: camminoUpdate.nome,
        luogo: camminoUpdate.luogo,
        id_nazione: camminoUpdate.id_nazione,
        active: camminoUpdate.active,
        nome_en: camminoUpdate.nome_en,
      })
    );
  } else {
    formData.append(
      "body",
      JSON.stringify({
        nome: camminoUpdate.nome,
        luogo: camminoUpdate.luogo,
        id_nazione: camminoUpdate.id_nazione,
        active: camminoUpdate.active,
        nome_en: camminoUpdate.nome_en,
      })
    );
  }

  let result = await axios.put(
    `${process.env.REACT_APP_API_KEY}/admin/tag/${camminoUpdate.id}`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true",
      },
    }
  );
  return result.data;
}

async function inserttag(
  token,
  insert_nome,
  insert_luogo,
  insert_file,
  id_nazione,
  nome_en
) {
  const formData = new FormData();
  formData.append("profileImg", insert_file);
  formData.append(
    "body",
    JSON.stringify({
      nome: insert_nome,
      luogo: insert_luogo,
      id_nazione: id_nazione,
      nome_en: nome_en,
    })
  );
  let result = await axios.post(
    `${process.env.REACT_APP_API_KEY}/admin/tag`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true",
      },
    }
  );
  return result.data;
}

async function getTag(token) {
  let result = await fetch(`${process.env.REACT_APP_API_KEY}/admin/tag`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((data) => data.json());
  return result;
}

const Cammini = () => {
  const [alloggi, setCammini] = useState([]);
  const [alloggiBackup, setCamminiBackup] = useState([]);
  const { token, setToken } = useToken();
  const [show_tag, setShowTag] = useState(false);
  const [tag, setTag] = useState();
  const [insert_file, setInsertFile] = useState();
  const [insert_luogo, setInsertLuogo] = useState();
  const [insert_nome, setInsertNome] = useState();
  const [selected_tag, setSelectedtag] = useState();
  const [fotoTag, setFotoTag] = useState("");
  const [upload_preview_tag, setUploadPreviewTag] = useState(
    "/immagine_profilo_default.svg"
  );
  const [foto, setFoto] = useState("");
  const [nazione, setNazione] = useState([]);
  const [nazione_selezionata, setNazioneSelezionata] = useState();
  const [input_visibility, setInputVisibility] = useState(false);
  const [nuova_nazione_input, setNazioneInput] = useState();
  const [loader, setLoader] = useState(false);
  const [modalError, setModalError] = useState("");
  const [nome, setNome] = useState();
  const [luogo, setLuogo] = useState("");
  const [nome_en, setNomeEn] = useState("");
  const [showInfo, setShowInfo] = useState("");
  const [show_update, setShowUpdate] = useState(false);
  const [id, setId] = useState();
  const [camminoUpdate, setCamminoUpdate] = useState({});
  const [selectedCammino, setSelectedCammino] = useState({});
  const [showInactive, setShowInactive] = useState(true);

  const handleCloseUpdate = async () => {
    let tag = await getTag(token);
    setCammini(tag);
    await setSelectedtag();
    setShowUpdate(false);
    await setInsertNome();
    await setInsertLuogo();
    await setInsertFile("");
    await setNome("");
    await setFoto("");
    await setLuogo("");
    await setUploadPreviewTag("/immagine_profilo_default.svg");
    setCamminoUpdate({});
  };

  const handleCloseInfo = async () => {
    await setSelectedtag();
    setShowInfo(false);
    await setNome("");
    await setFoto("");
    await setLuogo("");
    await setSelectedCammino({});
    await setUploadPreviewTag("/immagine_profilo_default.svg");
  };

  const handleCloseTag = async () => {
    setShowTag(false);
    setUploadPreviewTag("/immagine_profilo_default.svg");
    let tag_ = await getTag(token);
    setCammini(tag_);
    let tag = await getTag(token);
    await setTag(tag);
    await setInsertFile();
    await setInsertLuogo();
    await setInsertNome();
    await setSelectedtag();
    await setNazioneInput();
    await setNomeEn("");
  };

  const search = (keyword) => {
    let alloggi = alloggiBackup.filter((el) =>
      el.nome.toUpperCase().includes(keyword.toUpperCase())
    );
    if (alloggi?.length == 0) {
      alloggi = alloggiBackup.filter((el) =>
        el.nazione.toUpperCase().includes(keyword.toUpperCase())
      );
    }

    // Apply active/inactive filter
    if (!showInactive) {
      alloggi = alloggi.filter((el) => el.active === 1);
    }

    setCammini(alloggi);
  };

  const applyFilters = () => {
    let filteredCammini = alloggiBackup;
    
    // Apply active/inactive filter
    if (!showInactive) {
      filteredCammini = filteredCammini.filter((el) => el.active === 1);
    }

    setCammini(filteredCammini);
  };

  const get_alloggi = useEffect(() => {
    const fetchData = async () => {
      let nazione_ = await getNazioni(token);
      if (!nazione) {
        localStorage.removeItem("token");
        return;
      }
      setNazione(nazione_);
      let result = await getTag(token);
      setCammini(result);
      setCamminiBackup(result);
    };
    fetchData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [showInactive, alloggiBackup]);

  console.log(
    foto != "" &&
    foto != null &&
    upload_preview_tag == "/immagine_profilo_default.svg",
    upload_preview_tag,
    foto
  );
  return (
    <div>
      <Modal
        show={modalError != ""}
        onHide={() => {
          setModalError("");
        }}
      >
        <Modal.Body>
          <div>
            <img
              onClick={() => {
                setModalError("");
              }}
              className="btn-close-img"
              src="/closeBtn.svg"
            />
          </div>
          <div
            style={{
              textAlign: "center",
              paddingTop: "50px",
              paddingBottom: "80px",
            }}
          >
            <img
              style={{ width: "60px" }}
              className="btn-close-img1"
              src="/errorImage.svg"
            />
            <div
              style={{
                color: "#FF1400",
                fontSize: "1.4em",
                fontWeight: "500",
                marginTop: "20px",
                marginBottom: "0px",
              }}
            >
              {modalError}
              <br></br>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={showInfo}
        onHide={handleCloseInfo}
      >
        <Offcanvas.Header>
          <img
            onClick={handleCloseInfo}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Cammini - Info
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <div>
              <div>
                <div style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                  <div
                    className="div-image"
                    style={{
                      backgroundImage: `url("${foto}")`,
                      display: "inline-block",
                    }}
                  ></div>
                  <div
                    style={{
                      display: "inline-block",
                      position: "relative",
                      bottom: "50px",
                      left: "30px",
                    }}
                  >
                    <img
                      onClick={() => {
                        setCamminoUpdate({
                          ...selectedCammino,
                          nome_en: selectedCammino.nome_en || "",
                        });
                        setShowInfo(false);
                        setShowUpdate(true);
                      }}
                      style={{ marginBottom: "13px", cursor: "pointer" }}
                      src="/updateTable.svg"
                    />
                    <br></br>
                    {/*  <img
                                            onClick={() => {
                                                //setShowDelete(true);
                                                setShowInfo(false)
                                            }}
                                            style={{ cursor: "pointer" }} src="/deleteTable.svg" />
                                        */}
                  </div>
                  <div className=" mb-2">
                    <p className="nome">{nome}</p>
                    <p className="nome">{nome_en ? `(EN) ${nome_en}` : ''}</p>
                  </div>

                  <div className="md-form  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <b>Luogo</b>
                    <p>{luogo}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div>
              <div></div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={show_tag}
        onHide={handleCloseTag}
      >
        <Offcanvas.Header>
          <img
            onClick={handleCloseTag}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Cammini - Aggiungi
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
            <div>
              <div>
                <div>
                  <div style={{ marginTop: "40px" }} className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      style={{ marginBottom: "20px" }}
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Cambia Immagine
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "100px",
                          width: "100px",
                          display: "inline-block",
                          backgroundImage: `url(${fotoTag != "" &&
                            fotoTag != null &&
                            upload_preview_tag ==
                            "/immagine_profilo_default.svg"
                            ? foto
                            : upload_preview_tag
                            })`,
                          backgroundSize: "cover",
                          borderRadius: "100%",
                          backgroundPosition: "center",
                        }}
                      ></div>
                      <label
                        htmlFor={`upload-photo-Immagine`}
                        className="file"
                        style={{
                          width: "70%",
                          position: "relative",
                          left: "20px",
                          bottom: "8px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span>
                          <h6
                            style={{
                              display: "inline-block",
                              marginBottom: "0px",
                            }}
                          >
                            Cambia Immagine
                          </h6>
                        </span>
                        <input
                          type="file"
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-1",
                          }}
                          id={`upload-photo-Immagine`}
                          onChange={async (e) => {
                            if (e.target.files[0]) {
                              await setUploadPreviewTag(
                                URL.createObjectURL(e.target.files[0])
                              );
                            }
                            await setInsertFile(e.target.files[0]);
                          }}
                        />
                      </label>
                    </div>

                    {/* <input type="file" style={{ border: "none", width: "70%", display: "inline-block", position: "relative", left: "20px", bottom: "48px" }} onChange={async (e) => {
                                            if (e.target.files[0]) {
                                                await setUploadPreviewTag(URL.createObjectURL(e.target.files[0]))

                                            }
                                            await setInsertFile(e.target.files[0]);
                                        }} /> */}
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Nome
                    </label>
                    <input
                      defaultValue={insert_nome}
                      onChange={async (e) => {
                        await setNome(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name-en"
                    >
                      Nome (Inglese)
                    </label>
                    <input
                      onChange={async (e) => {
                        await setNomeEn(e.target.value);
                      }}
                      type="text"
                      id="orangeForm-name-en"
                      className="form-control validate"
                    />
                  </div>



                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-nazione"
                      style={{ marginBottom: "10px" }}
                    >
                      Regione
                    </label>
                    <select
                      id="orangeForm-nazione"
                      className="form-control validate"
                      onChange={async (e) => {
                        const regione = e.target.value;
                        if (!regione) return;
                        setLuogo(regione);
                        const existing = nazione?.find(
                          (item) =>
                            item.title &&
                            item.title.toLowerCase() === regione.toLowerCase()
                        );
                        if (existing) {
                          setNazioneInput(existing.id);
                        } else {
                          const insert = await insertNazione(token, regione);
                          if (insert.status == "ok") {
                            const result = await getNazioni(token);
                            setNazione(result);
                            const created = result.find(
                              (item) =>
                                item.title &&
                                item.title.toLowerCase() === regione.toLowerCase()
                            );
                            if (created) setNazioneInput(created.id);
                          }
                        }
                      }}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Seleziona una regione
                      </option>
                      {REGIONI_ITALIANE.map((regione) => (
                        <option key={regione} value={regione}>
                          {regione}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="">
                  {loader && (
                    <div style={{ textAlign: "center", paddingTop: "20px" }}>
                      <img src="/loader.gif" style={{ borderRadius: "100%" }} />
                    </div>
                  )}
                  {!loader && (
                    <button
                      onClick={async () => {
                        setLoader(true);
                        let check_campi = await checkCampiTag(
                          nome,
                          luogo,
                          insert_file,
                          upload_preview_tag
                        );
                        if (check_campi == true) {
                          await setModalError("");
                          let resultInsert = await inserttag(
                            token,
                            nome,
                            luogo,
                            insert_file,
                            nuova_nazione_input,
                            nome_en,
                          );
                          if (resultInsert.status == "ok") {
                            handleCloseTag();
                            await setModalError("");
                          }
                          setLoader(false);
                        } else {
                          setLoader(false);
                          await setModalError(check_campi);
                        }
                      }}
                      className="btn btn-deep-orange close btn-update"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Aggiungi
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="offcanvas-custom"
        placement="end"
        show={show_update}
        onHide={handleCloseUpdate}
      >
        <Offcanvas.Header>
          <img
            onClick={handleCloseUpdate}
            className="btn-close-img"
            src="/closeBtn.svg"
          />
          <p
            style={{
              color: "#B1B1B1",
              fontSize: "2em",
              marginBottom: "0",
              position: "absolute",
              left: "60px",
            }}
          >
            Cammini - Modifica
          </p>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
            <div>
              <div>
                <div>
                  <div style={{ marginTop: "40px" }} className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      style={{ marginBottom: "20px" }}
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Cambia Immagine
                    </label>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "100px",
                          width: "100px",
                          display: "inline-block",
                          backgroundImage: `url(${foto != "" &&
                            foto != null &&
                            upload_preview_tag ==
                            "/immagine_profilo_default.svg"
                            ? foto
                            : camminoUpdate.img
                            })`,
                          backgroundSize: "cover",
                          borderRadius: "100%",
                          backgroundPosition: "center",
                        }}
                      ></div>
                      <label
                        htmlFor={`upload-photo-Immagine`}
                        className="file"
                        style={{
                          width: "70%",
                          position: "relative",
                          left: "20px",
                          bottom: "8px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span>
                          <h6
                            style={{
                              display: "inline-block",
                              marginBottom: "0px",
                            }}
                          >
                            Cambia Immagine
                          </h6>
                        </span>
                        <input
                          type="file"
                          style={{
                            opacity: "0",
                            position: "absolute",
                            zIndex: "-1",
                          }}
                          id={`upload-photo-Immagine`}
                          onChange={async (e) => {
                            if (e.target.files[0]) {
                              await setUploadPreviewTag(
                                URL.createObjectURL(e.target.files[0])
                              );
                            }
                            setInsertFile(e.target.files[0]);
                          }}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                    >
                      Nome
                    </label>
                    <input
                      defaultValue={camminoUpdate.nome}
                      onChange={(e) => {
                        setCamminoUpdate({
                          ...camminoUpdate,
                          nome: e.target.value,
                        });
                      }}
                      type="text"
                      id="orangeForm-name"
                      className="form-control validate"
                    />
                  </div>

                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name-en"
                    >
                      Nome (Inglese)
                    </label>
                    <input
                      defaultValue={camminoUpdate.nome_en}
                      onChange={(e) => {
                        setCamminoUpdate({
                          ...camminoUpdate,
                          nome_en: e.target.value,
                        });
                      }}
                      type="text"
                      id="orangeForm-name-en"
                      className="form-control validate"
                    />
                  </div>

                  <div className="">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-name"
                      style={{ display: "inline" }}
                    >
                      Attivo
                    </label>
                    {camminoUpdate.active === 0 && (
                      <input
                        type="checkbox"
                        style={{
                          width: "15px",
                          position: "relative",
                          display: "inline",
                        }}
                        onChange={(e) => {
                          setCamminoUpdate({
                            ...camminoUpdate,
                            active: 1,
                          });
                        }}
                      />
                    )}
                    {camminoUpdate.active === 1 && (
                      <input
                        type="checkbox"
                        style={{
                          width: "15px",
                          position: "relative",
                          display: "inline",
                        }}
                        defaultChecked
                        onChange={(e) => {
                          setCamminoUpdate({
                            ...camminoUpdate,
                            active: 0,
                          });
                        }}
                      />
                    )}
                  </div>
                  <div className="  mb-2">
                    <i className="fas fa-user prefix grey-text"></i>
                    <label
                      data-error="wrong"
                      data-success="right"
                      for="orangeForm-nazione-update"
                      style={{ marginBottom: "10px" }}
                    >
                      Nazione
                    </label>

                    <select
                      id="orangeForm-nazione-update"
                      className="form-control validate"
                      onChange={async (e) => {
                        const selectedNazione = nazione.find(item => item.id == e.target.value);
                        if (selectedNazione) {
                          setCamminoUpdate({
                            ...camminoUpdate,
                            luogo: selectedNazione.title,
                            id_nazione: selectedNazione.id,
                          });
                        }
                      }}
                      value={nazione.find(item => item.title === camminoUpdate.luogo)?.id || ""}
                    >
                      <option value="" disabled>Seleziona una nazione</option>
                      {nazione.map((item, index) => {
                        return (
                          item.title != null && (
                            <option key={item.id} value={item.id}>
                              {item.title}
                            </option>
                          )
                        );
                      })}
                    </select>

                    {input_visibility && (
                      <div style={{ marginTop: "12px" }}>
                        <label
                          data-error="wrong"
                          data-success="right"
                          for="orangeForm-name"
                          style={{ marginBottom: "10px" }}
                        >
                          Nuova nazione
                        </label>
                        <div style={{ display: "flex" }}>
                          <input
                            style={{ width: "80%" }}
                            onChange={async (e) => {
                              await setNazioneInput(e.target.value);
                            }}
                            type="text"
                            id="orangeForm-name"
                            className="form-control validate"
                          />
                          <button
                            onClick={async () => {
                              let insert = await insertNazione(
                                token,
                                nuova_nazione_input
                              );
                              if (insert.status == "ok") {
                                let result = await getNazioni(token);
                                setNazione(result);
                                setInputVisibility(false);
                              }
                            }}
                            style={{
                              position: "relative",
                              float: "right",
                              border: "none",
                              boxShadow: "0px 3px 6px #00000029",
                              borderRadius: "20px",
                              height: "45px",
                              marginLeft: "2%",
                              fontSize: "0.9em",
                            }}
                          >
                            Aggiungi
                          </button>
                        </div>
                      </div>
                    )}

                    <button
                      onClick={async () => {
                        await setInputVisibility(!input_visibility);
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "0.9em",
                        color: "#707070",
                        marginTop: "0px",
                      }}
                    >
                      + Aggiungi Nazione
                    </button>
                  </div>
                </div>
                <div className="">
                  {loader && (
                    <div style={{ textAlign: "center", paddingTop: "20px" }}>
                      <img src="/loader.gif" style={{ borderRadius: "100%" }} />
                    </div>
                  )}
                  {!loader && (
                    <button
                      onClick={async () => {
                        setLoader(true);
                        await setModalError("");
                        let resultInsert = await updatetag(
                          camminoUpdate,
                          token
                        );
                        if (resultInsert.status == "ok") {
                          handleCloseUpdate();
                          await setModalError("");
                        }
                        setLoader(false);
                      }}
                      className="btn btn-deep-orange close btn-update"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        style={{
          paddingTop: "20px",
          width: "100%",
          backgroundColor: "#F4F4F4",
        }}
      >
        <h1 className="title-sezione">
          <img
            src="camminiIcon.svg"
            style={{
              position: "relative",
              bottom: "3px",
              width: "23px",
              marginRight: "12px",
            }}
            alt=""
          />
          Cammini
        </h1>

        <div style={{ marginTop: "30px", width: "100%", display: "flex", alignItems: "center", gap: "20px", marginBottom: "20px" }}>
          <div style={{ flex: 1 }}>
            <SearchForm nome="Cerca" search={search} />
          </div>

          <div style={{
            display: "flex",
            alignItems: "center"
          }}>
            <label style={{
              fontSize: "0.9em",
              color: "#707070",
              marginRight: "10px",
              fontWeight: "500",
              whiteSpace: "nowrap"
            }}>
              Mostra inattivi:
            </label>
            <input
              type="checkbox"
              checked={showInactive}
              onChange={(e) => setShowInactive(e.target.checked)}
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer"
              }}
            />
          </div>

          <button
            variant="primary"
            onClick={async () => {
              await setModalError("");
              await setNome("");
              await setLuogo("");
              await setFoto("");
              await setInsertFile("");
              await setUploadPreviewTag("/immagine_profilo_default.svg");
              setShowTag(true);
            }}
            className="btn btn-default btn-rounded mb-4 aggiungi-struttura "
            data-toggle="modal"
            data-target="#modalRegisterForm"
            style={{
              border: "none",
              boxShadow: "0px 3px 6px #00000029",
              borderRadius: "20px",
              height: "50px",
              paddingLeft: "20px",
              paddingRight: "20px",
              fontSize: "0.9em",
              whiteSpace: "nowrap"
            }}
          >
            Aggiungi Cammino
          </button>
        </div>
      </div>

      <div
        className="alloggi overflow-responsive Card"
        style={{
          paddingBottom: "100px",
          borderRadius: "25px",
          position: "relative",
          left: "",
          marginTop: "30px",
          width: "100%",
        }}
      >
        <div className="card-container">
          {alloggi.map((cammino) => (
            <div
              className="div-cammini"
              style={{
                padding: "10px",
                backgroundColor: "#ffffff",
                boxShadow: "0px 3px 6px #00000029",
                borderRadius: "20px",
                height: "auto",
              }}
              key={cammino.id}
            >
            <div
              style={{
                height: "110px",
                backgroundImage: `url("${cammino.img}")`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                borderRadius: "20px",
              }}
            ></div>
            <div style={{ padding: "10px", paddingBottom: "0" }}>
              {cammino.active == 0 && (
                <p
                  style={{
                    color: "red",
                    fontSize: "0.8em",
                    fontWeight: "700",
                    marginBottom: "0",
                  }}
                >
                  Non Attivo
                </p>
              )}
              {cammino.active == 1 && (
                <p
                  style={{
                    color: "#A9DE5B",
                    fontSize: "0.8em",
                    fontWeight: "700",
                    marginBottom: "0",
                  }}
                >
                  Attivo
                </p>
              )}
              <p
                style={{
                  color: "#B1B1B1",
                  fontSize: "1em",
                  fontWeight: "300",
                  marginBottom: "0",
                  wordBreak: "break-word",
                }}
              >
                {cammino.luogo}
              </p>
              <p
                style={{
                  color: "#2F2F2F",
                  fontSize: "1em",
                  fontWeight: "700",
                  marginBottom: "18px",
                  wordBreak: "break-word",
                }}
              >
                {cammino.nome}
              </p>

              <div>
                <button
                  onClick={async () => {
                    await setFoto(cammino.img);
                    await setNome(cammino.nome);
                    await setInsertNome(cammino.nome);
                    await setLuogo(cammino.luogo);
                    await setSelectedCammino(cammino);
                    setShowInfo(true);
                  }}
                  style={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    border: "none",
                    paddingLeft: "0",
                  }}
                >
                  <img style={{ width: "25px" }} src="./infoTable.svg" />
                </button>
                <button
                  onClick={async () => {
                    await setCamminoUpdate({
                      ...cammino,
                      nome_en: cammino.nome_en || "",
                    });
                    // Delay showing the update modal to ensure state is updated
                    setTimeout(() => {
                      setShowUpdate(true);
                    }, 100);
                  }}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    boxShadow: "none",
                    paddingLeft: "0",
                  }}
                >
                  <img style={{ width: "25px" }} src="./updateTable.svg" />
                </button>

                {/*
                                <button onClick={async () => {



                                }} style={{ backgroundColor: "transparent", border: "none", boxShadow: "none", paddingLeft: "0" }}><img style={{ width: "25px" }} src="./deleteTable.svg" /></button>
                            */}
              </div>
            </div>
          </div>
        ))}
        </div>
      </div>
    </div>
  );
};

export default Cammini;
